import React from "react";
import NextImage from "../NextImage";

export default function NormalSearchIcon() {
  return (
    <div className="w-6 h-6 rounded-[6.86px] ">
      <NextImage src="/assets/images/chat_normal.webp" width={24} height={24} />
    </div>
  );
}
